import { render, staticRenderFns } from "./EstimateTemplate.vue?vue&type=template&id=8984c072&scoped=true"
import script from "./EstimateTemplate.vue?vue&type=script&lang=js"
export * from "./EstimateTemplate.vue?vue&type=script&lang=js"
import style0 from "./EstimateTemplate.vue?vue&type=style&index=0&id=8984c072&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8984c072",
  null
  
)

export default component.exports